import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '../../button/button';
import { BagTickIcon, NextIcon } from '../../icons/icons';
import AccordionPanel from '../../accordion-panel/accordion-panel';
import BesicTable from '../../table/basicTable';
import CommentSection from '../../comment-section/comment-section';

function BookingDetailsTab({
  setSupplierTab,
  bookingInfo,
  itemsData,
  commentData,
  setTabDetails,
  columns,
}) {
  const [t] = useTranslation('manageorders');
  const packages = bookingInfo?.packages?.length
    ? bookingInfo?.packages
    : itemsData?.packages;

  return (
    <div className="supplier-booking-content">
      <div className="d-flex justify-between align-center">
        <h3>{t('manageordersscreen.bookingdetailsbtn.description')}</h3>
        {false && (
          <Button
            styles="primary"
            color="outline"
            label="Load Calculator"
            iconRight={<BagTickIcon />}
            spacing="0.208vw"
            size="medium"
          />
        )}
      </div>
      {packages?.length && (
        <AccordionPanel
          title={t('manageordersscreen.bookingdetailsbtn.addpackage')}
        >
          <BesicTable
            columns={columns}
            // bookingdetails.packages
            data={packages}
            className="supplier-booking auto-column-width"
          />
        </AccordionPanel>
      )}
      {commentData?.current?.comment && (
        <AccordionPanel
          title={t('manageordersscreen.bookingdetailsbtn.packagenotes')}
        >
          <CommentSection commentData={commentData?.current} />
        </AccordionPanel>
      )}

      <div className="supplier-booking-button-area">
        <Button
          label={t('manageordersscreen.bookingdetailsbtn.next')}
          styles="submit"
          size="large"
          className="px-24"
          onClick={() => {
            setTabDetails((prev) => {
              const updatedTabDetails = { ...prev };
              updatedTabDetails.bookingDetails = true;
              return updatedTabDetails;
            });
            setSupplierTab('shipment details');
          }}
          iconRight={<NextIcon />}
          spacing="0.694vw"
        />
      </div>
    </div>
  );
}

export default BookingDetailsTab;
BookingDetailsTab.propTypes = {
  setSupplierTab: PropTypes.func,
  bookingInfo: PropTypes.instanceOf(Object),
  itemsData: PropTypes.instanceOf(Object),
  commentData: PropTypes.instanceOf(Object),
  setTabDetails: PropTypes.func,
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
};
BookingDetailsTab.defaultProps = {
  setSupplierTab: () => {},
  bookingInfo: {},
  itemsData: {},
  commentData: {},
  setTabDetails: () => {},
};
